<div class="direct-debit-dialog">
  <div class="u-flex-center u-flex-column">
    <div class="custom-title u-flex grow">Make Payments Easier with Direct Debit!</div>
    <p class="u-flex mat-body-medium override-color">
      Set up direct debit to enjoy automatic, hassle-free payments for your Bruce’s Doggy Day Care subscription! With direct debit,
      your payments are handled securely, so you can focus on what matters most—your pup's happiness.
    </p>
    <p class="u-flex mat-body-medium override-color">
      Would you like to set up direct debit now?
    </p>
  </div>
  <div mat-dialog-actions class="u-flex-center">
    @if (loading) {
      <mat-spinner color="primary" diameter="50"></mat-spinner>
    }
    @if (!loading) {
      <button mat-raised-button color="primary" class="rounded" (click)="setupDirectDebit()">
        Yes, Set Up Direct Debit
      </button>
    }
    @if (!loading) {
      <button mat-raised-button class="rounded bddc-dark-blue mat-secondary" (click)="noThanks()">
        No, Continue with One-Time Payment
      </button>
    }
  </div>
</div>
